<script setup lang="ts">
import {
  ArrowUp,
} from "@lucide/vue";
import {
  useMediaQuery,
  useWindowScroll,
} from "@vueuse/core";

const route = useRoute();
const isMobile = useMediaQuery("(max-width: 767px)");
const {
  y,
} = useWindowScroll();

const hiddenRoutePrefixes = [
  "/exercise/interview",
];

const isHiddenRoute = computed(() =>
  hiddenRoutePrefixes.some((path) => route.path === path || route.path.startsWith(`${path}/`)),
);

const isVisible = computed(() => isMobile.value && y.value > 300 && !isHiddenRoute.value);

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
</script>

<template>
  <Transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0 translate-y-2 scale-95"
    enter-to-class="opacity-100 translate-y-0 scale-100"
    leave-active-class="transition duration-150 ease-in"
    leave-from-class="opacity-100 translate-y-0 scale-100"
    leave-to-class="opacity-0 translate-y-2 scale-95"
  >
    <button
      v-if="isVisible"
      type="button"
      class="fixed right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-white shadow-md transition hover:bg-primary-700 active:scale-95 md:hidden"
      :aria-label="$t('COMMON.SCROLL_TO_TOP')"
      :title="$t('COMMON.SCROLL_TO_TOP')"
      style="bottom: calc(env(safe-area-inset-bottom) + 1rem);"
      @click="scrollToTop"
    >
      <ArrowUp class="h-5 w-5" />
    </button>
  </Transition>
</template>
